import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NzFormatEmitEvent, NzTreeNode, NzTreeNodeOptions } from 'ng-zorro-antd/tree';

@Component({
    selector: 'clink-tree-multi-select',
    templateUrl: './tree-multi-select.component.html',
    styleUrls: ['./tree-multi-select.component.less'],
})
export class TreeMultiSelectComponent {
    // NzTreeNodeOptions props
    @Input() titleField = 'title'; // 标题
    @Input() keyField = 'key'; // 唯一标识
    @Input() childrenField = 'children'; // 子节点

    @Input() public set treeNodes(value: any[]) {
        if (!value || !Array.isArray(value)) {
            this.nodes = [];
        } else {
            this.nodes = this.conversionNodes(value);
        }
    }
    @Input() public set defaultCheckedKeys(value: any[]) {
        if (!value || !Array.isArray(value)) {
            this.checkedKeys = [];
        } else {
            const checkedKeys = [];
            value.forEach((item: any) => {
                if (typeof item === 'string') {
                    checkedKeys.push(item);
                } else if (Object.prototype.toString.call(item) === '[object Object]' && item[this.keyField]) {
                    checkedKeys.push(item[this.keyField]);
                } else if (Object.prototype.toString.call(item) === '[object Object]' && item.key) {
                    checkedKeys.push(item.key);
                }
            });
            this.checkedKeys = checkedKeys;
        }
    }
    @Input() inputPlaceholder = '输入座席名/座席号回车搜索'; // 搜索框占位符
    @Output() checkedChange = new EventEmitter(); // 勾选数据变更

    searchValue = ''; // 搜索值
    nodes: NzTreeNodeOptions[] | NzTreeNode[] = []; // 元数据
    checkedKeys = []; // 指定选中的树节点
    selectData = [];

    /**
     * 转换树节点
     *
     * @param {*} value
     * @return {*}  {NzTreeNodeOptions[]}
     * @memberof TreeMultiSelectComponent
     */
    conversionNodes(value): NzTreeNodeOptions[] {
        return value.map((element) => {
            const { [this.titleField]: title, [this.keyField]: key, [this.childrenField]: children } = element;
            const nodeObj = { title, key, children: [], isLeaf: true };
            if (children && Array.isArray(children)) {
                Object.assign(nodeObj, { children: this.conversionNodes(children), isLeaf: false });
            }
            return nodeObj;
        });
    }

    /**
     * 点击树节点 Checkbox 触发
     *
     * @param {*} event
     * @memberof TreeMultiSelectComponent
     */
    nzCheckBoxEvent(event: NzFormatEmitEvent): void {
        const params = event.checkedKeys;
        const selectData = [];
        if (params && Array.isArray(params)) {
            params.forEach((item) => {
                const { children, isLeaf } = item.origin;
                if (isLeaf) {
                    selectData.push(item);
                } else {
                    if (children && children.length) {
                        children.forEach((element) => {
                            selectData.push(element);
                        });
                    }
                }
            });
            this.selectData = selectData;
            this.checkedChange.emit(selectData);
        }
    }
}
